import script from "./DeviceSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeviceSettingsDialog.vue?vue&type=style&index=0&id=b1c9a604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c9a604"]])

export default __exports__